module.exports = __webpack_public_path__ + "img/00034.25b4f9a3.webp";